module.exports = __webpack_public_path__ + "PeBN-nJUPb_WsGYCw/agent-training-center_navigating_common_challenges.png";